import {Component} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {OrgantraegerDetail} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-umsatzsteuer',
  templateUrl: './umsatzsteuer.component.html'
})
export class UmsatzsteuerComponent extends FormBaseComponent<OrgantraegerDetail> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    if (this.data.isUmStOrgantraegerIdentischKStUndGewStOrgantraeger === undefined) {
      this.data.isUmStOrgantraegerIdentischKStUndGewStOrgantraeger = false;
    }
    if (this.data.isUmsatzsteuerOrgangesellschaft === undefined) {
      this.data.isUmsatzsteuerOrgangesellschaft = false;
    }
    if (this.data.beginnUStOrganschaft === undefined) {
      this.data.beginnUStOrganschaft = null;
    }
    this.form = this.formBuilder.group({
      ustIdentifikationsnummer: [this.data.ustIdentifikationsnummer,
        [
          this.validatorService.pattern('^(?=.{7,14}$)[A-Z]{2}[a-zA-Z0-9\\+\\*]*',
            this.translateService.instant('COMMON_UI.VALIDATION.UST_IDENTIFIKATION_NUMMER'))
        ]],
      isUmStOrgantraegerIdentischKStUndGewStOrgantraeger: [this.data.isUmStOrgantraegerIdentischKStUndGewStOrgantraeger, []],
      isUmsatzsteuerOrgangesellschaft: [this.data.isUmsatzsteuerOrgangesellschaft, []],
      beginnUStOrganschaft: [this.data.beginnUStOrganschaft, []]
    });
  }
}
